
import React, { useEffect, useState } from 'react';
import { Image, Text, View } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { LinearGradient } from 'expo-linear-gradient';
import { TouchableOpacity } from 'react-native-gesture-handler';
import HeaderDefault from '../../components/HeaderDefault';
import LineChartByActive from '../../components/LineChartByActive';
import NumberInput from '../../components/NumberInput';
import { formatGPXBalance, maxDecimals } from '../../utils/formatNumber'
import activesService from '../../services/activesService';
import balanceService from '../../services/balanceService';
import styles from './styles';

const Purchase = ({ navigation, route }) => {

    const [open, setOpen] = useState(false);
    const [actives, setActives] = useState([]);
    const [items, setItems] = useState([]);
    const [balance, setBalance] = useState('');
    const [viewType, setViewType] = useState('buy');

    const [amount, setAmount] = useState(0);
    const [selectedActive, setSelectedActive] = useState('0');
    const [selectedActiveObj, setSelectedActiveObj] = useState({});

    const [price, setPrice] = useState(0.00);
    const [authToken, setAuthToken] = useState(null);

    const [decimals, setDecimals] = useState(0);
    const [amountToken, setAmountToken] = useState(0);

    useEffect(() => {
        if (route?.params?.viewType) {
            setViewType(route.params.viewType);
        }
    }, []);
    useEffect(() => {
        console.log(actives)
    }, [actives])

    useEffect(() => {
        loadTokenAndRequest();
    }, [viewType]);

    useEffect(() => {
        actives.map((el) => {
            console.log(el.id + 'selectedActive - ' + selectedActive)
            if (el.id == selectedActive) {
                setSelectedActiveObj(el);
                if (el.single_value) {
                    setPrice(parseFloat(el.single_value));
                }
                if(el.name_token) {
                    if(['BTC', 'ETH', 'ADA'].indexOf(el.name_token) !== -1)
                        setDecimals(8);
                    if(!el.cryptoactive && ['BTC', 'ETH', 'ADA'].indexOf(el.name_token) === -1) {
                        loadAmountToken();
                    }else{
                        setAmountToken(0);
                    }
                }
            }
        });
        if (viewType === 'sell') {
            loadBalance();
        }
    }, [selectedActive]);

    useEffect(() => {
        if (authToken) {
            if (viewType === 'buy') {
                loadBalance();
                loadAllActives();
            } else {
                loadActivesWithBalance();
            }
        }
    }, [authToken]);

    const loadAmountToken = async () => {
        if(authToken) {
            activesService.getById(authToken, selectedActive).then((response) => {
                if(response.data?.count) {
                    setAmountToken(response.data?.count);
                }
            });
        }
    }

    const loadTokenAndRequest = async () => {
        const authTokenStorage = await AsyncStorage.getItem('JWT_TOKEN');
        setAuthToken(authTokenStorage);
    }

    const loadBalance = () => {
        if (authToken) {
            if (viewType === 'buy') {
                balanceService.getBalanceOfGpx(authToken).then((response) => {
                    if (response?.data?.balance?.length > 0) {
                        setBalance(response?.data?.balance[0].saldo + '');
                    }
                }).catch((error) => {
                });
            } else if (viewType === 'sell' && selectedActive) {
                balanceService.getBalanceOfToken(authToken, selectedActive).then((response) => {
                    setBalance(response?.data?.saldo + '');
                }).catch((error) => {
                });
            }
        }
    }

    const loadAllActives = () => {
        activesService.get(authToken).then((response) => {
            if (response.data.length > 0) {
                setActives(response.data[0]);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const loadActivesWithBalance = () => {
        activesService.getActivesWhereUserHasBalance(authToken).then((response) => {
            if (response.data.length > 0) {
                setActives(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const actionEnabled = () => {
        if (!selectedActive || !selectedActiveObj?.id) {
            return 'SELECIONE UM ATIVO';
        }
        if (amount.length === 0) {
            return 'DIGITE A QUANTIDADE';
        }
        if (balance.length === '') {
            return 'CARREGANDO';
        }
        if (viewType === 'buy') {
            if ((parseFloat(amount + '') * parseFloat(selectedActiveObj.single_value + '')) > parseFloat(balance + '')) {
                return 'SALDO INSUFICIENTE';
            }
            return 'COMPRAR';
        }
        if (viewType === 'sell') {
            if (parseFloat(amount + '') > parseFloat(balance + '')) {
                return 'SALDO INSUFICIENTE';
            }
            return 'VENDER';
        }
    }

    const hasBalanceToOperation = () => {
        if (viewType === 'sell') {
            if (parseFloat(amount + '') > parseFloat(balance + '')) {
                return false;
            }
            return true;
        } else {
            if (amount > 0 && price > 0 && parseFloat(amount * price) > balance) {
                return false;
            } else {
                return true;
            }
        }
    }

    return (
        <>
            <HeaderDefault title={viewType === 'buy' ? 'Comprar' : 'Vender'} />

            <View style={styles.content}>
                <Text style={styles.title}>Desejo {viewType === 'buy' ? 'comprar' : 'vender'}:</Text>
                <View style={styles.contentSelect}>
                    <select
                        // value={selectedActive}
                        onChange={id => { setSelectedActive(id.target.value) }}
                        style={{

                            marginTop: 10, maxWidth: 350, fontSize: 16, background: '#FFFFFF', border: '2px solid #DDD', borderRadius: 5, padding: 10, alignSelf: 'center', color: '#444444'
                        }}
                    >
                        <option value="0">Selecione um ativo</option>
                        {
                            actives.map((el, index) =>
                                <option key={index} value={el.id}>{el.name_token}</option>
                            )
                        }
                    </select>
                </View>
                {
                    selectedActive && selectedActive !== '0' ?
                        <>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ ...styles.textAmount, flex: 0.5, fontWeight: '400' }}>
                                    Preço
                                </Text>
                                <Text style={{ ...styles.textAmount, flex: 0.5, textAlign: 'right' }}>
                                    {selectedActiveObj.single_value && (formatGPXBalance(selectedActiveObj.single_value))} GPX
                                </Text>
                            </View>
                            <View style={{}}>
                                <Text style={{ textAlign: 'right', color: '#999999' }}>{selectedActiveObj.single_value && (formatGPXBalance(selectedActiveObj.single_value))} BRL</Text>
                            </View>

                            <View style={{ marginTop: 15, marginBottom: 15 }}>
                                {/* <LineChartByActive price={price} /> */}
                            </View>
                            <View style={{ justifyContent: "space-between", flexDirection: "row" }}>
                                <View style={{ flex: 1 }}>
                                    {
                                        !selectedActiveObj?.cryptoactive && parseInt(amountToken) > 0 &&
                                        <Text style={{ fontWeight: '700', fontSize: 16 }}>Quantidade disponível{"\n"}<Text style={{ fontWeight: '400', color: '#656565' }}>{amountToken} {selectedActiveObj && selectedActiveObj.name_token}</Text></Text>
                                    }
                                </View>
                                <View style={{ flex: 1 }}>
                                    <Text style={{ textAlign: 'right', fontWeight: '700', fontSize: 16 }}>Meu saldo{"\n"}<Text style={{ fontWeight: '400', color: (!hasBalanceToOperation() ? '#d63b20' : '#656565') }}>{selectedActiveObj && (viewType === 'buy' ? formatGPXBalance(balance) : (selectedActiveObj?.cryptoactive ? maxDecimals(balance, 8) : balance))} {selectedActiveObj && (viewType === 'buy' ? 'GPX/BRL' : selectedActiveObj.name_token)}</Text></Text>
                                </View>
                            </View>
                            <View>
                                <View style={{ marginTop: 15 }}>
                                    <Text style={styles.titlePurchase}>Quanto deseja?</Text>
                                    <View style={styles.contentPurchaseAmount}>
                                        <NumberInput
                                            minValue={0}
                                            value={amount}
                                            maxDecimalsParam={decimals}
                                            onChange={value => setAmount(value)} />
                                    </View>
                                    <View style={{ alignItems: 'center' }}>
                                        <Text style={{ color: '#656565', paddingTop: 5 }}>{amount > 0 && price > 0 && formatGPXBalance(amount * price)} GPX/BRL</Text>
                                    </View>
                                </View>
                            </View>
                            <View >
                                <TouchableOpacity disabled={amount > 0 ? false : true} style={styles.action_buttons_container} onPress={() => {
                                    if (actionEnabled() === 'COMPRAR' || actionEnabled() === 'VENDER') {
                                        navigation.navigate('ConfirmPurchaseOrSell', { qtd: amount, token: selectedActive, viewType: viewType })
                                    } else if (actionEnabled() === 'SALDO INSUFICIENTE') {
                                        navigation.navigate('DepositMethod')
                                    }
                                }}>
                                    <LinearGradient
                                        start={{ x: -1, y: 0 }}
                                        end={{ x: 1, y: 0 }}
                                        colors={viewType === 'buy' ? ["#00490C", "#32BFB1"] : ["#AA0000", "#FF5454"]}
                                        style={styles.action_button}
                                    >
                                        <Text style={styles.action_button_text} numberOfLines={1}>{actionEnabled()}</Text>
                                    </LinearGradient>
                                </TouchableOpacity>
                            </View>
                        </>
                        :
                        <View style={{ padding: 15, marginTop: 35 }}>
                            <Text style={{ textAlign: 'center' }}>Antes de continuar, selecione o que deseja {viewType === 'buy' ? 'comprar' : 'vender'}.</Text>
                        </View>
                }
            </View>
        </>
    );
}

export default Purchase;